import { usePlaybackVideoJsPlayer } from '@app/core/playback/video/useVideoPlaybackState';
import { videoToImage } from '@app/helpers/utils';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export function FrameImageToFieldHandler({
  urlField = 'thumbnailUrl',
  timeField = 'thumbOffsetMs',
}: {
  timeField?: string;
  urlField?: string;
}) {
  const player = usePlaybackVideoJsPlayer();
  const { setValue } = useFormContext();
  const thumbOffsetMs = useWatch({ name: timeField });

  useEffect(() => {
    if (!player) {
      return;
    }

    if (typeof thumbOffsetMs !== 'number') {
      return;
    }

    const videoElement = player.el().getElementsByTagName('video')[0];

    if (!videoElement) {
      return;
    }

    setValue(urlField, videoToImage(videoElement));
  }, [thumbOffsetMs, urlField, setValue, player]);

  return null;
}
